/**
 * Pages Routes
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Routes, Navigate } from 'react-router-dom';

import ContractStudent from 'Routes/contract/students';
import ProgramInclusions from 'Routes/contract/programinclusion';
import ContractDashboard from 'Routes/contract/contractdashboard';
import StudentDownload from 'Routes/contract/studentdownload';
import StudentId from 'Routes/contract/studentid';
import ViewAgreement from 'Routes/contract/parentagreement';
import ViewDocument from 'Routes/contract/parentdocument';
import ContractRenewal from 'Routes/contract/contractrenewal';

// app config
import AppConfig from 'Constants/AppConfig';

const Pages = () => (
    <div className="content-wrapper">
        <Helmet>
            <title>Travel | {AppConfig.appTitle}</title>
            <meta name="description" content="TSGA Master" />
        </Helmet>

        <Routes>
            {/* Redirect from root to /students */}
            <Route path="/" element={<Navigate to="students" replace />} />

            <Route path="programInclusions" element={<ProgramInclusions />} />
            <Route path="students" element={<ContractStudent />} />
            <Route path="contractDashboard" element={<ContractDashboard />} />
            <Route path="contractrenewal" element={<ContractRenewal />} />
            <Route path="studentdownload" element={<StudentDownload />} />
            <Route path="studentid" element={<StudentId />} />
            <Route path="viewagreement" element={<ViewAgreement />} />
            <Route path="viewdocument" element={<ViewDocument />} />
        </Routes>
    </div>
);

export default Pages;
